<template>
    <el-dialog
        :visible.sync="abnormalResultVisible"
        :show-close="false"
        center
        width="420px"
        :before-close="handleClose">
        <div class="abnormal">
            <div class="abnormal_title">处理结果</div>
            <p class="abnormal_result_msg">{{details.result_content}}</p>
            <!-- <div class="abnormal_line"></div> -->
            <div class="abnormal_img">
                <div class="abnormal_img_item" v-for="(item,index) in details.result_imageurl" :key="index">
                    <img :src="$imgUrl + item" alt="">
                </div>
                
            </div>
            <div class="abnormal_action">
                <el-button type="primary" @click="handleClose">确定</el-button>
            </div>
        </div>
        

    </el-dialog>
   
</template>

<script>
export default {
    props:["abnormalResultVisible","details"],
   data (){
       return {
           value:'',
           imgList:[],
           selectIconIndex:''
       }
   },
   components: {
       
   },
   watch: {
       
   },
   computed: { 
       
   },
   methods: { 
       deleteImg(index){
           this.imgList.splice(index,1);
       },
       imgUpload(data){
           this.imgList.push(data.image_path);
       },
       handleClose(){
            this.$emit("update:abnormalResultVisible",false)   
       }
   },
   created() {
       
   },
   mounted() {
       
   }
}
</script>

<style scoped lang='less'>
.abnormal{
    // padding: 0 35px;
    .abnormal_result_msg{
        font-size:16px;
        color:#333;
        line-height: 24px;
    }
    &_title{
        font-size: 20px;
        color:#333;
        font-weight: 500;
        text-align: center;
        margin-bottom:20px;
    }
    &_line{
        border-top:1px solid #E5E5E5;
        height: 1px;
        width:100%;
        margin:16px 0 16px 0; 
    }
    &_img{
        display: flex;
        margin-top:20px;
        &_item{
            
            margin-right:10px;
            position: relative;
            img{
                width:70px;
                height: 70px;
            }
        }
    }
    &_action{
        text-align: center;
        margin-top:30px;
        /deep/ .el-button{
            width:104px;
            font-size: 16px;
            font-weight: normal;
            padding: 11px 19px;
        }
    }
    /deep/ .el-textarea__inner{
        background: #F9F9F9;
    }
}
</style>



// WEBPACK FOOTER //
// src/pages/orderDetails/components/abnormalResult.vue